module.exports = __webpack_public_path__ + "img/openDoor.0d439bcf.png";